export default __webpack_public_path__ + "static/media/archies.652fb102.png";